import { render, staticRenderFns } from "./BoxPendencias.vue?vue&type=template&id=53a9307f&"
import script from "./BoxPendencias.vue?vue&type=script&lang=js&"
export * from "./BoxPendencias.vue?vue&type=script&lang=js&"
import style0 from "./BoxPendencias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports